import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";

const initialState = window.__PRELOADED_STATE__;
ReactDOM.hydrate(
  <BrowserRouter>
    <App props={initialState} />
  </BrowserRouter>,
  document.getElementById("root")
);

// bla If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
